import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class HttpDateUTCInterceptorService implements HttpInterceptor {

  updateDates(obj: any) {
    const dates: [string, any][] = Object.entries(obj)
      .filter(([, value]: [string, any]) => value instanceof Date);

    for (const [key, value] of dates) {
      obj[key] = new Date(value.getTime() - value.getTimezoneOffset() * 60000);
    }
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.body === undefined || req.body === null) {
      return next.handle(req);
    }

    (req.body instanceof Array ? req.body : [req.body])
      .forEach((obj: any) => this.updateDates(obj));

    return next.handle(req);
  }

}
